export default "__VITE_ASSET__CJAE7n9z__"